import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

type TabType = 'home' | 'team' | 'invite' | 'me'

const TAB_MAP: Record<string, TabType> = {
  '/team': 'team',
  '/invite': 'invite',
  '/me': 'me',
}

/**
 * 根应用业务逻辑 Hook
 */
export function useApp() {
  const navigate = useNavigate()
  const location = useLocation()

  const getActiveTabFromPath = (pathname: string): TabType => {
    return TAB_MAP[pathname] || 'home'
  }

  const [activeTab, setActiveTab] = useState<TabType>(() =>
    getActiveTabFromPath(location.pathname),
  )

  // 监听路由变化，同步更新 activeTab
  useEffect(() => {
    setActiveTab(getActiveTabFromPath(location.pathname))
  }, [location.pathname])

  const handleTabChange = (tab: TabType) => {
    setActiveTab(tab)
    const path = tab === 'home' ? '/' : `/${tab}`
    navigate(path)
  }

  return {
    activeTab,
    handleTabChange,
  }
}
